import { memo } from "react"
import {
  MoreHorizontal,
  Eye,
  Pen,
  Download,
  Copy,
  Archive,
  Trash2,
} from "lucide-react"
import { Menu, MenuTrigger, MenuPopup, MenuItem, MenuSeparator } from "@/components/ui/menu"
import type { DemoDocument } from "@/types/demo.types"

interface DocumentActionsMenuProps {
  doc: DemoDocument
}

export const DocumentActionsMenu = memo(({ doc }: DocumentActionsMenuProps) => {
  return (
    <Menu>
      <MenuTrigger
        className="p-2 rounded-lg hover:bg-muted transition-colors focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1"
        onClick={(e) => e.stopPropagation()}
        aria-label={`Actions for ${doc.name}`}
      >
        <MoreHorizontal className="w-4 h-4 text-muted-foreground" aria-hidden="true" />
      </MenuTrigger>
      <MenuPopup align="end" sideOffset={4}>
        <MenuItem>
          <Eye className="w-4 h-4" />
          View
        </MenuItem>
        <MenuItem>
          <Pen className="w-4 h-4" />
          Edit
        </MenuItem>
        <MenuItem>
          <Download className="w-4 h-4" />
          Download
        </MenuItem>
        <MenuItem>
          <Copy className="w-4 h-4" />
          Duplicate
        </MenuItem>
        <MenuSeparator />
        <MenuItem>
          <Archive className="w-4 h-4" />
          Archive
        </MenuItem>
        <MenuItem variant="destructive">
          <Trash2 className="w-4 h-4" />
          Delete
        </MenuItem>
      </MenuPopup>
    </Menu>
  )
})

DocumentActionsMenu.displayName = "DocumentActionsMenu"
